import { useLayoutEffect, type ReactNode } from 'react'

/** Commit the SPA only once its lazy route is ready; no hydration or duplicate visible page. */
export default function PublicPrerenderHandoff({ children }: { children: ReactNode }) {
  useLayoutEffect(() => {
    document.getElementById('lupa-public-prerender')?.remove()
    document.getElementById('lupa-public-prerender-style')?.remove()
    document.documentElement.classList.remove('lupa-prerender-js', 'lupa-prerender-app')
  }, [])
  return children
}
